export enum userNotesFormFields {
  content = 'content',
  type = 'type',
  userId = 'userId',
}
